import React from 'react';
import styles from './profile-header.module.scss';
import AvatarC from '../../common/avatar';
import { ProfileInfo } from '../profile-details.interface';

const ProfileHeader = ({ user }: ProfileInfo) => {
  return (
    <div className={styles.profileHead}>
      <div className={styles.profileBackside}></div>
      <div className={styles.profileWrap}>
        <div className={styles.profileImg}>
          <AvatarC
            image={user.url}
            label={user.firstName?.slice(0, 1) + user.lastName?.slice(0, 1)}
            size='xlarge'
            shape='circle'
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProfileHeader);
